import { useNavigate, useParams } from 'react-router-dom'
import { Spinner } from '~/shadcn/ui/spinner'
import { useUserNotifications } from '~/@biz_notifications/user-notifications/useUserNotifications'
import { useProjectDetailQuery } from '../project-detail/useProjectDetailQuery'
import { ProjectDetailBlur } from '../project-detail/project-detail_ui/project-detail-blur/ProjectDetailBlur'
import { type GetOrderOfferDataParams } from './order-form/useOrderOfferDataQuery'
import { OrderForm } from './order-form/OrderForm'
import { useInvestmentsQuery } from '~/@pages_account-portfolio/investments/investments-table/useInvestmentsQuery'
import { useUser } from '~/@biz_account/useUser/useUser'
import { useQueryClient } from '~/@mid_query/client/useQueryClient'

function OrderPage() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { businessId, stageNumber } = useParams<GetOrderOfferDataParams>()
  const { reloadNotifications } = useUserNotifications()
  const { reloadInvestments } = useInvestmentsQuery({
    filter: undefined,
    sort: undefined,
  })
  const { reloadUser } = useUser()
  const { data: project, isFetching } = useProjectDetailQuery({
    businessId: businessId!,
    stageNumber: stageNumber!,
  })

  if (isFetching) return <Spinner className="size-6" />
  if (!project?._hasUserAccessToProject) return <ProjectDetailBlur />

  return (
    <>
      <OrderForm
        project={project}
        onOrderCreated={() => {
          // PK: Removed await to prevent users from staying on the orderPage with enabled buttons while waiting for a slow investment reload.
          reloadInvestments()
          reloadNotifications()
          queryClient.invalidateQueries({ queryKey: ['transactions'] })
          reloadUser()
          navigate('/account')
        }}
      />
      {!project?._hasUserAccessToProject && <ProjectDetailBlur />}
    </>
  )
}

export default OrderPage
